'use client'

import styles from './PublisherHeader.module.scss'
import { useTransition } from 'react'
import setLocale from '@/modules/langService/setLocale'

interface LanguageItemProps {
  short: string
  language: string
}

function LanguageItem ({ short, language }: LanguageItemProps) {
  const [isPending, startTransition] = useTransition()

  function setLanguage () {
    // set NEXT_LOCALE cookie
    startTransition(() => {
      setLocale(short)
      window.location.reload()
    })
  }

  return (
    <div
      className={styles.choice}
    >
      <span
        className={styles.languageSelect}
        onClick={() => {
          if (!isPending) setLanguage()
        }}
      >
        {language}
      </span>
    </div>
  )
}

export default LanguageItem
